<template>
  <section
    id="head-area"
    class="head-area"
    data-midnight="white"
  >
    <div class="my-10 mx-10 md:mx-20 mt-40">
      <div
        id="heroBg"
        class="rounded-md p-6"
      >
        <carousel
          :per-page="1"
          :navigate-to="someLocalProperty"
          :mouse-drag="false"
          :autoplay="true"
          :loop="true"
        >
          <slide>
            <div class="flex gap-8 flex-col md:flex-row  items-center">
              <div class="rounded-md w-full md:w-1/2">
                <img
                  src="theme-assets/images/herosection1.png"
                  alt=""
                  class="rounded-md"
                >
              </div>

              <div class="md:w-1/2 w-full  text-white flex flex-col item">
                <h2 class="mb-6 font-bold text-2xl">
                  Housing Research
                </h2>
                <p>
                  Navigate the Housing Landscape with Our <br>
                  Research Platform.  <br>
                </p>
                <button
                  class="rounded-sm md:w-2/6 w-1/2  mt-12 py-2 px-6 bg-green-800 text-white"
                  @click="$router.push('/housing-price')"
                >
                  Read More
                </button>
              </div>
            </div>
          </slide>
          <slide>
            <div class="flex gap-8 flex-col md:flex-row  items-center">
              <div class="rounded-md w-full md:w-1/2">
                <img
                  src="theme-assets/images/own-a-home.jpg"
                  alt=""
                  class="rounded-md"
                >
              </div>

              <div class="md:w-1/2 w-full  text-white flex flex-col item">
                <h2 class="mb-6 font-bold text-2xl">
                  Own a home 
                </h2>
                <p>
                  Get easy access to latest housing market data  <br>
                  in Nigeria.  <br>
                </p>
                <button
                  class="rounded-sm md:w-2/6 w-1/2  mt-12 py-2 px-6 bg-green-800 text-white"
                  @click="$router.push('/property-own-a-home')"
                >
                  Read More
                </button>
              </div>
            </div>
          </slide>
          <slide>
            <div class="flex gap-8 flex-col md:flex-row  items-center">
              <div class="rounded-md w-full md:w-1/2">
                <img
                  src="theme-assets/images/housing-market.jpeg"
                  alt=""
                  class="rounded-md"
                >
              </div>

              <div class="md:w-1/2 w-full  text-white flex flex-col item">
                <h2 class="mb-6 font-bold text-2xl">
                  Housing Market Directory
                </h2>
                <p>
                  Get easy access to housing market professionals <br>
                  & institutions based on their functions.   <br>
                </p>
                <button
                  class="rounded-sm md:w-2/6 w-1/2  mt-12 py-2 px-6 bg-green-800 text-white"
                  @click="$router.push('/housing-market')"
                >
                  Read More
                </button>
              </div>
            </div>
          </slide>
        </carousel>
      </div>
    </div>
  </section>
</template>



<script>

import { Carousel, Slide } from 'vue-carousel';

export default  {
  name: 'HeroSection',
  components: { Carousel,
    Slide,
    },

  data () {
    return {
    }
  },

  computed: {

  },
}
</script>